import { ToolsFrame } from "../styles";
import React from "react";
import { Redirect } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_TOOL_URL } from "../queries";
import { isMobile } from "react-device-detect";
import WarningBanner from "../../../../WarningBanner";

export default function CFBStatEngine() {
  const { data, loading, error } = useQuery(GET_TOOL_URL, {
    variables: { name: "CFB Stats" },
  });

  if (loading) return <></>;
  if (error) {
    return <Redirect to="/memberships" />;
  }
  return (
    <>
      {isMobile ? (
        <WarningBanner>
          This tool is not optimized for mobile usage. For best experience,
          please visit on a computer.
        </WarningBanner>
      ) : null}

      <ToolsFrame
        src={data.toolUrlByName.url}
        name="toolsFrame"
        scrolling="yes"
        marginHeight="0px"
        marginWidth="0px"
        allowFullScreen=""
        frameBorder="0"
      />
    </>
  );
}
